import React, { Fragment } from 'react';
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import ContactSection from '../../components/ContactSection';
import Journey from '../../components/journey/journey';
import FeaturesSection from '../../components/FeaturesSection/FeaturesSection';
import blank_img from '../../images/blank_img.png'

const HelpCenter = (props) => {

    return (
        <Fragment>
            <Header />
            <main className="page_content about-page">
                <section className="intro_about_section section_space">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <h1>We are the go-to choice for <br/> small property owners.</h1>
                                    <br/>
                                    <p className='mb-0'>That’s why every hour another property owner chooses to partner with us.</p>
                                </div>
                            </div>
                        </div>
                </section>
                <FeaturesSection />
                <section className="intro_about_section section_space">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 text-center">
                                <p>CRM-related video to solve your problems at every step.</p>
                            </div>
                            <div className="col-lg-4">
                                <img src={blank_img}/>
                            </div>
                            <div className="col-lg-4">
                                 <img src={blank_img}/>
                            </div>
                            <div className="col-lg-4">
                                 <img src={blank_img}/>
                            </div>
                            <div className="col-lg-4">
                                 <img src={blank_img}/>
                            </div>
                            <div className="col-lg-4">
                                 <img src={blank_img}/>
                            </div>
                            <div className="col-lg-4">
                                 <img src={blank_img}/>
                            </div>
                            <div className="col-lg-4">
                                 <img src={blank_img}/>
                            </div>
                            <div className="col-lg-4">
                                 <img src={blank_img}/>
                            </div>
                            <div className="col-lg-4">
                                 <img src={blank_img}/>
                            </div>
                            <div className="col-lg-4">
                                 <img src={blank_img}/>
                            </div>
                            <div className="col-lg-4">
                                 <img src={blank_img}/>
                            </div>
                            <div className="col-lg-4">
                                 <img src={blank_img}/>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <PageTitle pageTitle={'Contact Us'} pagesub={'Us 😍'} pageTop={'Contact'} /> */}
                <ContactSection />
                <Journey />
                {/* <CtaSection /> */}
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default HelpCenter;